import * as React from "react"
import { IconButton } from "@chakra-ui/react"
/* import { FaRegCopy } from "react-icons/fa" */
import { CopyIconProps } from "./types"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { RxCopy } from "react-icons/rx"
import { useCustomToast, ToastConfigProps } from "../../../hooks/useToast"

const _CopyIcon: React.FC<CopyIconProps> = ({
  textToCopy,
  textForToast,
  otherProps
}) => {
  const roomStyles = useRecoilValue(brandingSelector)

  const config: ToastConfigProps = {
    toastOptions: {
      containerStyle: {
        margin: "0.1rem"
      }
    },
    titleStyles: {
      fontWeight: 700
    }
  }
  const showToastMessage = useCustomToast(config)

  const handleCopyClick = () => {
    const textarea = document.createElement("textarea")
    textarea.value = textToCopy
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    showToastMessage(textForToast)
  }

  return (
    <>
      <IconButton
        aria-label="copy-icon"
        fontSize="xs"
        size="xs"
        icon={<RxCopy />}
        backgroundColor={
          roomStyles?.secondaryAccessButtonBackgroundColor ?? "#1AC541"
        }
        borderColor={
          roomStyles?.secondaryAccessButtonBorderColor ?? "transparent"
        }
        border={
          roomStyles?.secondaryAccessButtonBorderColor
            ? `1px solid ${
                roomStyles?.secondaryAccessButtonBorderColor
                  ? roomStyles.secondaryAccessButtonBorderColor
                  : "transparent"
              }`
            : "0px"
        }
        color={roomStyles?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
        onClick={handleCopyClick}
        _hover={{
          backgroundColor:
            roomStyles?.secondaryAccessButtonMouseoverColor ?? "#24A840",
          color:
            roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
        }}
        {...otherProps}
      />
    </>
  )
}

export const CopyIcon = React.memo(_CopyIcon)
